module.exports = __webpack_public_path__ + "static/media/dabao_2.e693d390.png";